import { IMetadataProvider } from "./IMetadataProvider";

export class MetadataProvider implements IMetadataProvider {
    private _metadata: any = {};

    merge(metadata: any): void {
        this._metadata = {...this._metadata, ...metadata};
    }    
    
    get(key: string) {
        key = key.charAt(0).toLowerCase() + key.slice(1);
        if(this._metadata.hasOwnProperty(key)){
            //TODO: handle instance metadata
            return this._metadata[key].default;
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/app/pillar/workspace/services/MetadataProvider.ts